export enum PHONE_CALL_BOOKING_TABS {
  BOOK_A_PHONE_CALL = 'Umów się na spotkanie z mentorem',
  ADD_ORGANIZER_AVAILABILITY = 'Dodaj swoją dyspozycyjność',
  PLANNED_PHONE_CALLS = 'Zaplanowane spotkania'
}

export type PhoneCallBookingTab =
  (typeof PHONE_CALL_BOOKING_TABS)[keyof typeof PHONE_CALL_BOOKING_TABS]
